export default "__VITE_ASSET__186723c5__"